import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { FormType } from "@/core/services/api/interfaces/dict/CreateTransactionPage";
import { Transaction } from "@/core/services/api/interfaces/manager/Transaction";
import { TransactionMethod } from "@/core/services/api/enums/TransactionMethod";
import GrandTotalEndpoint from "@/core/services/api/endpoints/manager/GrandTotalEndpoint";

class CreateTransactionEndpoint {
  public [TransactionMethod.CARD](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/transactions/card", form as AxiosRequestConfig);
  }

  public [TransactionMethod.CRYPTO](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/transactions/crypto", form as AxiosRequestConfig);
  }

  public [TransactionMethod.IBAN](form: FormType): Promise<AxiosResponse> {
    return $api.post("manager/transactions/iban", form as AxiosRequestConfig);
  }

  public [TransactionMethod.TRANSFER](form: FormType): Promise<AxiosResponse> {
    return $api.post(
      "manager/transactions/transfer",
      form as AxiosRequestConfig
    );
  }

  public [TransactionMethod.EXCHANGE](form: FormType): Promise<AxiosResponse> {
    return $api.post(
      "manager/transactions/transfer",
      form as AxiosRequestConfig
    );
  }

  public [TransactionMethod.CONVERT](form: FormType): Promise<AxiosResponse> {
    return $api.post(
      "manager/transactions/convert",
      form as AxiosRequestConfig
    );
  }

  public [TransactionMethod.IMPORT](form: FormType): Promise<AxiosResponse> {
    const formData = new FormData();
    for (const column in form) {
      formData.append(column, form[column]);
    }

    return $api.direct({
      url: "manager/transactions/import",
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

class TransactionAgentsEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("manager/transactions/agents", params);
  }
  public get(id: number | string): Promise<AxiosResponse> {
    return $api.get(`manager/transactions/agents/${id}`);
  }
  public update(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(`manager/transactions/agents/${id}`, params);
  }
  public store(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.post(`manager/transactions/agents`, params);
  }
  public delete(id: number | string, page = 1): Promise<AxiosResponse> {
    return $api.delete(`manager/transactions/agents/${id}?page=${page}`);
  }
}

class TransactionEndpoint {
  constructor(
    public create: CreateTransactionEndpoint = new CreateTransactionEndpoint(),
    public agents: TransactionAgentsEndpoint = new TransactionAgentsEndpoint(),
    public grand_total: GrandTotalEndpoint = new GrandTotalEndpoint()
  ) {}

  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("manager/transactions", params);
  }

  public metadata(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("manager/transactions-metadata", params);
  }

  public item(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`manager/transactions/${id}`, params);
  }

  public updateSourceOfFunds(
    id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.put(`manager/transactions/${id}/source-of-funds`, params);
  }

  public deny(transaction: Transaction): Promise<AxiosResponse> {
    return $api.put(`manager/transactions/${transaction.id}/deny`);
  }

  public downloadWireConfirmation(
    transaction: Transaction,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.responseType = "blob";

    return $api.get(
      `manager/transactions/${transaction.id}/wire-confirmation`,
      params
    );
  }
}

export default TransactionEndpoint;
